const VUE_COMPONENTS_SELECTOR = "[data-vue-component]";

import Vue from "vue"
Vue.config.productionTip = false

// Import Data Store
import store from './store.js';

// Register global components so it can be loaded via html
import GlobalComponents from './components/globals';
for (const ComponentName in GlobalComponents) {
	Vue.component(ComponentName, GlobalComponents[ComponentName]);
}

Vue.prototype.$store = store;

// Special Vue Components: Wishlist page
if (document.querySelector("#wishlist")) {
	new Vue({
		el: "#wishlist",
		data: {
			state: store.state
		},
	})
}

// Special Vue Components: Region Listing
if (document.querySelector('[data-region-directory-map]')) {
	new Vue({
		el: '[data-region-directory-map]',
	})
}

// Generic Vue Components
const allVueComponents = document.querySelectorAll(VUE_COMPONENTS_SELECTOR);
Array.prototype.forEach.call(allVueComponents, el => {
	new Vue({
		el,
		data: {
			state: store.state
		},
	})
});
